






import { defineComponent } from '@nuxtjs/composition-api';
import { BaseHeading } from '@shared/ui';

export default defineComponent({
  name: 'HeroTitle',
  components: {
    BaseHeading,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
  },
});
